import * as ExcelJS from "exceljs";
import { GetNestedField } from "@core/utils/Object";

interface IExcelFileHeaders {
  name: string;
  field: string;
  width?: number;
}

export const useExportToExcel = () => {
  const exportExcelFile = (headers: IExcelFileHeaders[], data: any[], fileName = 'download') => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Sheet 1");

    sheet.getRow(1).font = {
      bold: true
    };

    sheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center"
    };

    sheet.columns = headers.map((header, index) => {
      const headerCell = sheet.getRow(1).getCell(index + 1);

      headerCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "A0A0A0" }
      };
      headerCell.border = {
        bottom: { style: 'thin', color: { argb: "000000" } },
        right: { style: 'thin', color: { argb: "000000" } }
      };

      return {
        header: header.name,
        key: header.field,
        width: header.width || 20
      };
    });

    data.forEach((row) => {
      const aux = {};
      headers.forEach((header) => {
        aux[header.field] = row[header.field];
      });
      sheet.addRow(aux);
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `${fileName}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  return {
    exportExcelFile
  };
};
